<template>
  <v-container class="py-0 px-5">
    <v-row>
      <v-col cols="12">
        <data-selector
          v-model="userTrainingTask.training_task_id"
          :disabled="true"
          field-name="task_id"
          source-type="training-tasks"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
      >
        <date-field
          v-model="userTrainingTask.success_date"
          field-name="date"
          rules="date"
          autofocus
        />
      </v-col>
      <v-col
        cols="12"
      >
        <validated-text-field
          v-model="userTrainingTask.comment"
          field-name="comment"
          rules="max:500"
          type="text"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'EditUserTrainingTask',
    props: {
      userTrainingTask: Object,
    },
  }
</script>
